import React from 'react';

const LeftSideLayout1 = () => {
	return <></>;
};

export default React.memo(LeftSideLayout1);
